export default "__VITE_PUBLIC_ASSET__1b9130d1__"